export const production = {
  production: true,
  name: "production",
  useEmulators: false,
  commit: 'productioncommit',
  firebase: {
    apiKey: 'AIzaSyC-dkXUWdL7WOUw6FdurAta5NPKRKXEJJg',
    authDomain: 'segui-production.firebaseapp.com',
    databaseURL: 'https://segui-production.firebaseio.com',
    projectId: 'segui-production',
    storageBucket: 'segui-production.appspot.com',
    messagingSenderId: '758797864296',
    appId: '1:758797864296:web:f84e38594919fdc6711add',
    measurementId: 'G-W61D6MLFJG',
  },
  recaptcha: {
    siteKey: '6LfCbMYrAAAAAFjyvnFWBH0IF4TqyFPIggbGoA5Q',
  },
  urls: {
    segue: 'https://segment.innersightlabs.com',
    segui: 'https://diary.innersightlabs.com',
    xview: 'https://3d.innersightlabs.com',
    console: 'https://console.innersightlabs.com',
    meshBaseUrl: 'https://storage.googleapis.com/3d-segui-production/models',
  }
};
